import React from "react";
import classnames from "classnames";

import { Wrapper } from "../Wrapper";
import { Text } from "../Text";
import { getResizedImageURL } from "../utils";
import styles from "./FeaturesIncluded.module.scss";

export const FeaturesIncluded = ({ data }: any) => (
  <section
    className={classnames(styles.wrapper, {
      [styles.wrapperGrey]: data.background_colour === "Grey",
    })}
  >
    <Wrapper isExtraLarge>
      <Text
        isSubheading
        isCenter
        text={data.title}
        style={{
          fontWeight: "bold",
          fontSize: "36px",
          marginBottom: "40px",
        }}
      />
      <ul className={styles.cols}>
        {data.features_row_1.map((feature: any, idx: number) => {
          const imgURL = getResizedImageURL(feature.image.url, 640) || "";
          return (
            <li className={styles.col} key={idx}>
              <img alt={feature.image.alt} src={imgURL} />
              <h4>{feature.name}</h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: feature.text,
                }}
              />
            </li>
          );
        })}
      </ul>
      {data.features_row_2 && (
        <ul className={`${styles.cols} ${styles.colsExtra}`}>
          {data.features_row_2.map((feature: any, idx: number) => {
            const imgURL = getResizedImageURL(feature.image.url, 640) || "";
            return (
              <li className={styles.col} key={idx}>
                <img alt={feature.image.alt} src={imgURL} />
                <h4>{feature.name}</h4>
                <p
                  dangerouslySetInnerHTML={{
                    __html: feature.text,
                  }}
                />
              </li>
            );
          })}
        </ul>
      )}
    </Wrapper>
  </section>
);
